import { atom } from "jotai";

import { type MeReadDto } from "@/config/apiClient";

// We trick the compiler to think that User will always be defined.
// That won't be the case, but the router of our App is only accessible when you're connected
export const userAtom = atom<MeReadDto | null | undefined>(null);
